<template>
	<div>
		<van-dropdown-menu>
			<van-dropdown-item title="笔刷" ref="item">
				<div class="slot-content">
					<div class="list">
						<div class="item-title">笔刷粗细：{{lineWidth}}</div>
						<div class="item-1">
							<van-slider v-model="lineWidth" min="1" />
						</div>
					</div>
					<div class="list">
						<div class="item-title">笔刷颜色</div>
						<div class="item-2">
							<div class="item-color" @click="selectColor(index)"
								:style="[{backgroundColor:item},{boxShadow:(index == selectedIndex?'0 0 0 5px #ebebeb':'')}]"
								v-for="(item,index) in colorList" :key='index'></div>
						</div>
					</div>
					<van-button type="danger" block round @click="bsClick">
						确认
					</van-button>
				</div>
			</van-dropdown-item>
			<van-dropdown-item :title="modeTitle" ref="item1">
				<div class="slot-content">
					<div class="list">
						<div class="item-title">描绘图形</div>
						<div class="item-2-1">
							<div class="textItem" @click="selectCard(index)"
								:style="[{color:(index == cardIndex?'#000':'#777')}]" v-for="(item,index) in cardList"
								:key='index'>{{item}}</div>
						</div>
					</div>
					<van-button type="danger" block round @click="cardClick">
						确定
					</van-button>
				</div>
			</van-dropdown-item>
			<van-dropdown-item :title="funcTitle" ref="item2">
				<div class="slot-content">
					<div class="list">
						<div class="item-title">功能</div>
						<div class="item-2">
							<div class="textItem" @click="clickFunc('cx')">删除</div>
							<div class="textItem" @click="clickFunc('xpc')">橡皮擦</div>
							<div class="textItem" @click="clickFunc('clear')">清除画布</div>
							<div class="textItem" @click="clickFunc('saveCanvas')">保存</div>
						</div>
						<div class="item-title">图片</div>
						<div class="item-2">
							<img src="../../../assets/icon-1.png" class="imageIcon" @click="selectImage('icon-1')" />
							<img src="../../../assets/icon-2.png" class="imageIcon" @click="selectImage('icon-2')" />
							<img src="../../../assets/icon-3.png" class="imageIcon" @click="selectImage('icon-3')" />
							<img src="../../../assets/circle.png" class="imageIcon-1" @click="circle" />
							<van-uploader :after-read="afterRead" preview-size='40' />
						</div>
						<div class="item-title">输入控件</div>
						<div class="item-2">
							<div class="textItem" @click="inputFont">输入文字</div>
						</div>
					</div>
					<!-- <van-button type="danger" block round @click="otherConfirm">
						确定
					</van-button> -->
				</div>
			</van-dropdown-item>
		</van-dropdown-menu>
		<van-popup v-model:show="show" round ref="popup" style="width: 70%;">
			<div class="content">
				<div class="title">提示</div>
				<div class="input">
					<van-field placeholder='请输入序号' v-model="number" type="digit" />
				</div>
				<div class="btn">
					<van-button @click="close" round type="default" size="small" style="width: 70px;">取消</van-button>
					<van-button round type="primary" size="small" style="width: 70px;margin-left: 20px;"
						@click="confirm">确认</van-button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				colorList: ['#000000', '#FF0D00', '#0066FF', '#FFFF10', '#79EF5D', '#C0C0C0'],
				selectedIndex: 0,
				cardList: ['自由绘图', '直线', '三角形', '正方形', '圆形', '长方形', '五角星', '箭头', '图片'],
				cardIndex: 0,
				lineWidth: 4,
				modeTitle: '模式',
				image: null,
				funcTitle: '其他',
				number: null,
				show: false,
			}
		},
		mounted() {
			this.modeTitle = this.cardList[this.cardIndex]
		},
		methods: {
			//笔刷颜色
			selectColor(index) {
				this.selectedIndex = index
			},
			//选择形状
			selectCard(index) {
				this.cardIndex = index
			},
			//笔刷确定
			bsClick() {
				this.$refs.item.toggle()
				this.$emit('selectColor', this.colorList[this.selectedIndex], this.lineWidth)
			},
			//描绘图形
			cardClick() {
				this.$refs.item1.toggle()
				this.modeTitle = this.cardList[this.cardIndex]
				this.$emit('selectCard', this.cardList[this.cardIndex])
			},
			//上传图片
			uploadImage() {
				this.$emit('uploadImage')
			},
			//点击图片
			selectImage(image) {
				this.cardIndex = this.cardList.length - 1
				this.modeTitle = this.cardList[this.cardIndex]
				this.$refs.item2.toggle()
				this.$emit('selectImage', image)
			},
			close() {
				this.$refs.popup.close()
			},
			confirm() {
				if (this.number) {
					this.$refs.popup.close()
					this.cardIndex = this.cardList.length - 1
					this.modeTitle = this.cardList[this.cardIndex]
					this.$emit('circle', this.number)
				}
			},
			//添加图标
			circle() {
				this.$refs.item2.toggle()
				this.show = true
			},
			//选择本地图片
			afterRead(e) {
				this.cardIndex = this.cardList.length - 1
				this.modeTitle = this.cardList[this.cardIndex]
				this.$refs.item2.toggle()
				this.$emit('uploadImage', e.content)
			},
			//功能
			clickFunc(type) {
				if (type == 'xpc') {
					this.funcTitle = '橡皮擦'
				} else if (type == 'cx') {
					this.funcTitle = '删除'
				}
				this.$refs.item2.toggle()
				this.$emit('clickFunc', type)
			},
			//输入文字
			inputFont() {
				this.funcTitle = '输入文字'
				this.$refs.item2.toggle()
				this.$emit('inputFont')
			}
		}
	}
</script>

<style>
	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 20px;
		align-items: center;

		.title {
			font-size: 14px;
			color: #333;
		}

		.input {
			margin: 30px 0;
		}

		.btn {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}

	.slot-content {
		padding: 30px;
		background-color: #FFFFFF;
	}

	.list {
		display: flex;
		flex-direction: column;
	}

	.item-title {
		color: #333;
		font-size: 14px;
		font-weight: bold;
	}

	.item-1 {
		margin: 30px 20px;
	}

	.item-2 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 30px 20px;
	}

	.item-2-1 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 30px 0;
	}

	.item-color {
		border-radius: 50%;
		height: 30px;
		width: 30px;
	}

	.textItem {
		font-size: 12px;
	}

	.item-color:active {
		animation: selectAni 0.3s ease-in infinite;
		-webkit-animation: selectAni 0.3s ease-in infinite;
	}

	@keyframes selectAni {
		0% {
			transform: scale(1.2);
		}

		33% {
			transform: scale(1.4);
		}

		66% {
			transform: scale(1.1);
		}

		100% {
			transform: scale(1);
		}
	}

	.imageIcon {
		width: 40px;
		height: 40px;
	}

	.imageIcon-1 {
		width: 30px;
		height: 30px;
	}

	.van-uploader__upload {
		margin: 0;
		width: 40px;
		height: 40px;
	}
</style>
